import { render, staticRenderFns } from "./ClientAddCulture.vue?vue&type=template&id=051298e6&"
import script from "./ClientAddCulture.vue?vue&type=script&lang=js&"
export * from "./ClientAddCulture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports